const SET_DANH_SACH_LOAI_LICH_LAM_VIEC = (state, danhSachLoaiLichLamViec) => {
  state.danhSachLoaiLichLamViec = danhSachLoaiLichLamViec;
};
const SET_DANH_SACH_LICH_LAM_VIEC = (state, danhSachLichLamViec) => {
  state.danhSachLichLamViec = danhSachLichLamViec;
};

const LAY_DANH_SACH_THEO_LOAI_LICH_CHA_THANH_CONG = (state, danhSachLoaiLich) => {
    state.danhSachLoaiLichCon = danhSachLoaiLich;
};
const LAY_CHI_TIET_LOAI_LICH_THANH_CONG = (state, loaiLich) => {
    state.chiTietLichLamViec = loaiLich;
};

export default {
  SET_DANH_SACH_LOAI_LICH_LAM_VIEC,
  SET_DANH_SACH_LICH_LAM_VIEC,
  LAY_DANH_SACH_THEO_LOAI_LICH_CHA_THANH_CONG,
    LAY_CHI_TIET_LOAI_LICH_THANH_CONG
};
